import * as Yup from "yup";

export const dataModel = {
  dateInit: "",
  // code: "",
  article: "",
  batchOut: "",
 

};

export const validationDataModel = () => {
  return Yup.object().shape({
    dateInit: Yup.date().required("forms.validations.required"),
    // code: Yup.string().required("forms.validations.required"),
    article: Yup.string().required("forms.validations.required"),
    batchOut: Yup.string().required("forms.validations.required"),

  });
};

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
